﻿export interface IMicrositeRecipientImagePosition {
    x: number;
    y: number;
}
